<template>
  <li :class="{'danger': statusIsOverdue}">
    <a href="" @click.prevent="navigateToComponent" :class="{'disabled': statusIsUpcoming }">
      <div class="row align-items-center">
        <div class="col-12 col-xl-4">
          <p class="strong">{{ task.name | nullable }}</p>
        </div>

        <div class="col-12 col-lg-7 col-xl-3">
          <p v-if="$userIsGraduate">{{ task.agency | nullable }}</p>
          <p v-if="$userIsManager || $userIsCoordinator">{{ task.graduate.name }}</p>
        </div>

        <div class="col col-lg-3 text-lg-right">
          <p class="text-muted small" v-if="statusIsUpcoming">Opens: {{ task.open_date | date }}</p>
          <p class="text-muted small" v-else>Due: {{ task.due_date | date }}</p>
        </div>

        <div class="col-auto col-lg-2 text-right">
          <span class="status" :class="statusSpanClass">{{ this.task.task_status }}</span>
        </div>
      </div>
    </a>
  </li>
</template>

<style scoped>
  .disabled {
    pointer-events: none;
  }

  .no-access {
    pointer-events: none;
  }
</style>

<script>
import { alert } from 'utils'

export default {
  props: {
    task: {
      required: true,
      type: Object
    }
  },

  computed: {
    statusIsOverdue () {
      return this.task.task_status === 'overdue'
    },

    statusIsOpen () {
      return this.task.task_status === 'open'
    },

    statusIsUpcoming () {
      return this.task.task_status === 'upcoming'
    },

    statusSpanClass () {
      if (this.statusIsOverdue) {
        return 'status-danger'
      }

      if (this.statusIsOpen) {
        return 'status-success'
      }

      return 'status-info'
    },

    placementComponentRoute () {
      if (this.$userIsGraduate) {
        if (this.task.type === 'start') {
          return { name: 'placements.single.start.performance', params: { placementId: this.task.placement_id } }
        } else {
          return { name: 'placements.single.end.objectives', params: { placementId: this.task.placement_id } }
        }
      } else if (this.$userIsManager || this.$userIsCoordinator) {
        if (this.task.type === 'start') {
          return { name: 'placements.single.start.manager.performance', params: { placementId: this.task.placement_id, graduateId: this.task.graduate.id } }
        } else {
          return { name: 'placements.single.end.manager.performance', params: { placementId: this.task.placement_id, graduateId: this.task.graduate.id } }
        }
      }

      return { name: '' }
    },

    pendingGraduateEntry () {
      return (this.$userIsManager || this.$userIsCoordinator) && (this.task.status === 'draft' || this.task.status === null)
    },

    managerNotAssigned () {
      return !this.task.is_assigned_manager
    }
  },

  methods: {
    async navigateToComponent () {
      if (this.pendingGraduateEntry) {
        alert.warning({
          title: 'Pending Graduate Entry',
          text: 'Unable to start task until graduate has submitted their content.'
        })
      } else if (this.$userIsGraduate && this.managerNotAssigned) {
        alert.warning({
          title: 'Manager Not Assigned',
          text: 'Your placement manager must be assigned on-system before you can commence creating your PDP. \n Ensure you have discussed and defined your objectives together with your manager before beginning. \n \n Please speak with your Agency Coordinator to assign your manager.'
        })
      } else {
        this.$router.push(this.placementComponentRoute)
      }
    }
  }
}
</script>

<style>
  .swal-text {
    text-align : center !important;
  }
</style>
